<template>
  <b-container>
    <b-row >      
      <b-col>
      <div class="server">
        <b-form-group label="Nome do servidor" label-for="DbServerName">
          <b-form-input
            type="text"
            id="DbServerName"
            placeholder="Informe o nome do servidor"
            v-model="model.dbServerName"
          />
          <span class="text-danger" v-if="modelstate['DbServerName']">
            {{ modelstate["DbServerName"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Porta do servidor" label-for="DbPort">
          <b-form-input
            type="text"
            id="DbPort"
            placeholder="Informe a porta do servidor"
            v-model="model.dbPort"
          />
          <span class="text-danger" v-if="modelstate['DbPort']">
            {{ modelstate["DbPort"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Usuário do servidor" label-for="DbUserName">
          <b-form-input
            type="text"
            id="DbUserName"
            placeholder="Informe o usário do servidor"
            v-model="model.dbUserName"
          />
          <span class="text-danger" v-if="modelstate['DbUserName']">
            {{ modelstate["DbUserName"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Senha do servidor" label-for="DbPassword">
          <b-form-input
            type="text"
            id="DbPassword"
            placeholder="Informe a senha do servidor"
            v-model="model.dbPassword"
          />
          <span class="text-danger" v-if="modelstate['DbPassword']">
            {{ modelstate["DbPassword"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Base de dados" label-for="DbSchema">
          <b-form-input
            type="text"
            id="DbSchema"
            placeholder="Informe a base de dados"
            v-model="model.dbSchema"
          />
          <span class="text-danger" v-if="modelstate['DbSchema']">
            {{ modelstate["DbSchema"][0] }}
          </span>
        </b-form-group>
      </div>
      </b-col>
      <b-col>
      <div class="api">
        <b-form-group label="ApiGuid (Token)" label-for="ApiGuid">
          <b-form-input
            type="text"
            id="ApiGuid"
            placeholder="Informe a ApiGuid"
            v-model="model.apiGuid"
          />
          <span class="text-danger" v-if="modelstate['ApiGuid']">
            {{ modelstate["ApiGuid"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Usuário da API" label-for="ApiUserName">
          <b-form-input
            type="text"
            id="ApiUserName"
            placeholder="Informe o nome do Usuário"
            v-model="model.apiUserName"
          />
          <span class="text-danger" v-if="modelstate['ApiUserName']">
            {{ modelstate["ApiUserName"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Senha do usuário da API" label-for="ApiPassword">
          <b-form-input
            type="text"
            id="ApiPassword"
            placeholder="Informe a senha"
            v-model="model.apiPassword"
          />
          <span class="text-danger" v-if="modelstate['ApiPassword']">
            {{ modelstate["ApiPassword"][0] }}
          </span>
        </b-form-group>
        <b-form-group label="Url base da API" label-for="ApiPassword">
          <b-form-input
            type="text"
            id="ApiPassword"
            placeholder="Informe a url base da API"
            v-model="model.apiUrlBase"
          />
          </b-form-group>
      </div>
      </b-col>
    </b-row>
    <!-- <div>{{model}}</div> -->
  </b-container>
</template>

<script>
export default {
  name: "SystemIntegrationCreateCrudData",
  props: {
    model: Object,
    modelstate: Object,
  },
};
</script>
<style scoped>
</style>